import {Modal} from '@/components/atoms';
import {MODAL_TYPE} from '@/utils/constants/globalStyle';

export const getModal = ({
  title,
  text,
  showPrimaryButton,
  primaryButtonText,
  onClickPrimaryButton,
  showSecondaryButton,
  secondaryButtonText,
  onClickSecondaryButton,
  showModal,
  onCloseModal,
  hideCloseButton
}) => {
  return (
    <Modal
      type={MODAL_TYPE.FLUID}
      showModal={showModal}
      onCloseModal={onCloseModal}
      title={title}
      text={text}
      showPrimaryButton={showPrimaryButton}
      primaryButtonText={primaryButtonText}
      onClickPrimaryButton={onClickPrimaryButton}
      showSecondaryButton={showSecondaryButton}
      secondaryButtonText={secondaryButtonText}
      onClickSecondaryButton={onClickSecondaryButton}
      footerProps={{
        size: 'medium',
        type: 'primary'
      }}
      isDark={true}
      hideCloseButton={hideCloseButton}
    />
  );
};
